/* @flow */

import { rem } from 'polished';

import { fadeDuration, pressDuration } from '@e180/ui/lib/token/animation';
import { antialiasing } from 'src/shared/app/base/style/token/helper';
import { mediumGrey } from '@e180/ui/lib/token/palette';
import { hoverSelector } from '@e180/ui/lib/token/selector';
import { baseFontSize, baseFontFamily } from '@e180/ui/lib/token/typography';

export default {
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    color: mediumGrey,

    textAlign: 'center',
    textDecoration: 'none',

    transition: [
      ['opacity', fadeDuration],
      ['transform', pressDuration],
    ],

    [hoverSelector]: {
      opacity: 0.5,
    },
    '&:active': {
      transform: 'scale(0.90, 0.90)',
    },
  },
  'root-has-sponsors': { borderBottom: ['solid', 2, mediumGrey] },

  text: {
    extend: antialiasing,

    fontSize: rem(15, baseFontSize),
    lineHeight: 1,
    opacity: 0.5,
    fontFamily: baseFontFamily,
    fontWeight: 600,
    paddingBottom: -20,
  },
  platform: {
    display: 'inline',
  },
  logo: {
    width: ({ imgWidth }: Object) => imgWidth,
    maxHeight: 140,
    margin: [20, 'auto', 0],
    padding: [0, 20],
    paddingBottom: 30,

    objectFit: 'contain',

    '$root-large &': {
      height: 100,
      marginTop: rem(20, baseFontSize),
    },

    '$root-xlarge &': {
      height: 150,
      marginTop: rem(20, baseFontSize),
    },
  },
};
